import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxCommentCaptionsComponent } from './comment-captions.component';
import { MarkerModule } from '../marker';
import { SanitizePipeModule } from '@go-modules/pipes/sanitize/sanitize.pipe.module';
@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		MarkerModule,
		SanitizePipeModule
	],
	declarations: [
		NgxCommentCaptionsComponent
	],
	exports: [
		NgxCommentCaptionsComponent
	]
})
export class NgxCommentCaptionsModule {}
